<template>
  <div @touchstart="handleTouchStart" @touchend="handleTouchEnd">
    <div class="header">
      <div @click="goBack()" class="img"><img src="@/assets/images/back.png" alt=""></div>
      <div>{{ dataInfo.label }}</div>
    </div>
    <div class="box">
      <div class="card-box">
        <div class="card-title">{{ dataInfo.title }}</div>
        <div class="time">{{ dataInfo.time }}</div>
        <div class="content" v-html="dataInfo.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
      created() {
        this.dataInfo = JSON.parse(localStorage.getItem('dataInfo'))
      },
      mounted() {},
      data() {
          return {
            dataInfo: {},
            startX: '',
            endX: ''
          }
      },
      methods: {
        goBack() {
          this.$router.go(-1)
        },
        handleTouchStart(event) {
        // 获取触摸开始的X坐标
        this.startX = event.touches[0].clientX
        },
        handleTouchEnd(event) {
          // 阈值，滑动距离超过这个值才考虑为有效滑动。可根据各自的设备修改
          const threshold = 70
          // 获取触摸结束的X坐标
          this.endX = event.changedTouches[0].client
          // 计算滑动距离
          const deltaX = this.endX - this.startX
          if (deltaX > threshold) {
            // 向左滑动，返回上一页
            history.back() // 返回上一页
          }
        }
      },
      computed: {},
      watch: {},
      filters: {},
      components: {}
  }
  </script>

  <style lang="scss" scoped>
  .header{
    position: fixed;
    top:0;
    width: 100%;
    height: 88px;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 25px;
    text-align: left;
    font-style: normal;
    padding: 40px 0 0 0;
    .img{
       img{
        height: 20px;
       }
      position: absolute;
      left: 16px;
      top: 53px;
    }
  }
  .box{
    background: #F5F6F8;
    padding: 16px 16px 100px 16px;
    min-height: calc(100vh - 44px);
    margin-top: 88px;
  }
  .card-box{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(222,229,243,0.3);
    padding: 12px 20px;
    border-radius: 6px;
    .card-title{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #334694;
        line-height: 22px;
        text-align: left;
        font-style: normal;
    }
    .time{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #AAAAAA;
        line-height: 17px;
        text-align: left;
        font-style: normal;
        border-bottom: 1px solid #F1F1F1;
        padding: 8px 0;
    }
    .content{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        padding-top: 8px;
    }
}
</style>
